import paceTokensTemplate from './paceTokens.html';

/*******************************************************************************
 * @ngdoc    component
 * @name     csm.books.OurOrg.component:paceTokens
 * @constructor
 * @param {object=} apiTokens    Pace processor tokens.
 * @param {string}  defaultName  Default account name = fuzeAccountID.
 * @description
 * Takes input of Pace processor tokens.
 *******************************************************************************/
export const paceTokensComponent = {
  template: paceTokensTemplate,
  bindings: { apiTokens: '<', defaultName: '=' },
  controller: paceTokensController
}

/* @ngInject */ function paceTokensController($scope) {
  const $ctrl = this;
  const setName = (nv) => ($ctrl.defaultName = nv);
  $scope.$on(
    'destroy',
    $scope.$watch('$ctrl.apiTokens.fuzeAccountID', setName)
  );
}